/** @format */

import {
  Button,
  Loading,
  Modal,
  TextInput,
  Tile,
} from "carbon-components-react";
import { useEffect, useState, useRef } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import UIShell from "../../components/UIShell";
import UIShellPagination from "../../components/UIShellPagination";
import PageHelper from "../../helpers/Pagehelper";
import {
  fetchAllQuestions,
  bulkDeleteQuestion,
  updateFaq,
} from "../../redux/actions/faqAction";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

function FaqsPage({ isLoading }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isLoadingData, setIsLoadingData] = useState(true);

  const headers = [
    {
      key: "title",
      header: "Question",
    },
    {
      key: "description",
      header: "Answer",
    },
  ];

  const [paginationContent, setPaginationContent] = useState({
    query: "",
    page: 0,
    limit: 20,
    total: 0,
    totalItems: 0,
    rows: [],
  });

  const [modalContent, setModalContent] = useState({
    modalHeading: "",
    isOpen: false,
    faqId: undefined,
    title: undefined,
    description: undefined,
  });

  const mapToColumn = (row) => {
    return {
      _id: row._id,
      title: row.title,
      description: row.description,
    };
  };

  const updateFaqDetail = () => {
    dispatch(
      updateFaq(
        {
          faqId: modalContent.faqId,
          question: modalContent.title,
          answer: answer,
        },
        () => {
          // reset modal content
          setAnswer("");
          setModalContent({
            modalHeading: "",
            isOpen: false,
            faqId: undefined,
            title: undefined,
            description: undefined,
          });

          fetch({ query: "", page: 0, limit: paginationContent.limit });
        }
      )
    );
  };

  const bulkDelete = async (_items) => {
    dispatch(
      bulkDeleteQuestion(
        {
          questionIds: _items.map((v) => ({
            _id: v.id,
          })),
        },
        () => {
          fetch({ query: "", page: 0, limit: paginationContent.limit });
        }
      )
    );
  };

  const viewCategoryDetail = (_data) => {
    const faqId = _data[0].id.split(":")[0];
    const title = _data.filter((v) => v.info.header === "title")[0]?.value;
    const description = _data.filter((v) => v.info.header === "description")[0]
      ?.value;

    setAnswer(description);

    setModalContent((v) => ({
      isOpen: true,
      modalHeading: `${title}`,
      faqId,
      title,
      description,
    }));
  };

  const paginationChange = async (_newPage) => {
    fetch({
      query: paginationContent.query,
      page: _newPage,
      limit: paginationContent.limit,
    });
  };

  const searchTable = async (e) => {
    const { value } = e.target;

    fetch({
      query: value,
      page: 0,
      limit: paginationContent.limit,
    });
  };

  const fetch = ({ query, page, limit }) => {
    setIsLoadingData(true);
    dispatch(
      fetchAllQuestions(
        { query, page, limit },
        ({ filteredData, totalFiltered, total }) => {
          setPaginationContent((v) => ({
            ...v,
            skip: totalFiltered,
            query,
            limit,
            page,
            total,
            totalItems: PageHelper.getTotalItems(total, limit),
            rows: filteredData.map(mapToColumn),
          }));
          setIsLoadingData(false);
        }
      )
    );
  };

  useEffect(() => {
    fetch(paginationContent);
  }, []);

  const [answer, setAnswer] = useState("");

  return (
    <UIShell breadcrumbs={[{ name: "Home", link: "/" }, { name: "Faq" }]}>
      {isLoadingData && <Loading />}
      <UIShellPagination
        dataTableList={paginationContent.rows}
        headers={headers}
        searchTable={searchTable}
        bulkDelete={bulkDelete}
        createForm={() => history.push("/faqs/form")}
        viewDetail={viewCategoryDetail}
        paginationChange={paginationChange}
        totalItems={paginationContent.totalItems}
        page={paginationContent.page}
        withExpander={true}
        isHtmlContent
      />

      <Modal
        modalHeading={modalContent.modalHeading}
        modalLabel="Faq details"
        primaryButtonText="Update"
        primaryButtonDisabled={isLoading}
        secondaryButtonText="Cancel"
        open={modalContent.isOpen}
        onRequestSubmit={() => updateFaqDetail()}
        onRequestClose={() => setModalContent((v) => ({ ...v, isOpen: false }))}
      >
        <TextInput
          data-modal-primary-focus
          labelText="Question"
          placeholder="question"
          value={modalContent.title}
          onChange={(_v) =>
            setModalContent((v) => ({ ...v, title: _v.target.value }))
          }
          style={{ marginBottom: "1rem" }}
        />

        <ReactQuill theme="snow" value={answer} onChange={setAnswer} />
      </Modal>
    </UIShell>
  );
}

const mapStateToProps = (state) => {
  return {
    dataTableList: state.faqReducer.dataTableList,
    isLoading: state.uxReducer.isLoading,
  };
};

export default connect(mapStateToProps)(FaqsPage);
